import { PlanBenefitOverrideRuleTemplateKey } from '../enums/plan-benefit-override-rule.enum'

function formatEntries(
  params: Record<string, unknown>,
  separator: string
): string {
  const entries = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== null
  )
  if (entries.length === 0) return '—'
  return entries.map(([k, v]) => `${k}: ${v}`).join(separator)
}

export const PLAN_BENEFIT_OVERRIDE_RULE_PATTERN_FORMATTER: Record<
  PlanBenefitOverrideRuleTemplateKey,
  (params: Record<string, unknown>) => string
> = {
  [PlanBenefitOverrideRuleTemplateKey.PARTIAL_FIELD_UPDATE]: (params) =>
    formatEntries(params, ' · '),
  [PlanBenefitOverrideRuleTemplateKey.UPSERT_RULE]: (params) =>
    formatEntries(params, ' · '),
}

export const PLAN_BENEFIT_OVERRIDE_RULE_TOOLTIP_FORMATTER: Record<
  PlanBenefitOverrideRuleTemplateKey,
  (params: Record<string, unknown>) => string
> = {
  [PlanBenefitOverrideRuleTemplateKey.PARTIAL_FIELD_UPDATE]: (params) =>
    formatEntries(params, '\n'),
  [PlanBenefitOverrideRuleTemplateKey.UPSERT_RULE]: (params) =>
    formatEntries(params, '\n'),
}
